export const ITEMS_TYPES = {
  TICKET: 'ticket',
  DONATION: 'donation',
  STANDALONE_ADDON: 'standalone_addon',
  PROMO_CODE: 'promo_code',
};
